import { faker } from '@faker-js/faker';
import { sample } from 'lodash';
// utils
import { mockImgProduct } from '../utils/mockImages';

// ----------------------------------------------------------------------

const PRODUCT_NAME = [
  'Absecon',
  'Martin County',
];

const PRODUCT_IMG = [
  'https://img1.wsimg.com/isteam/ip/cf1c8c3c-fe98-460a-b6dd-83c99998c7f4/84108865_2566341756932719_3482121087142068224_.jpg',
  'https://raw.githubusercontent.com/gqc/azure-test-images/main/Martin%20County/MartinCountyThumbnail.PNG'
  // 'http://1p67cm1tqpkp1d8tgmaxznbc-wpengine.netdna-ssl.com/wp-content/uploads/2019/08/florida-map.jpg',
]

const PRODUCT_SUB = [
  'New Jersey',
  'Florida',
]
const PRODUCT_COLOR = [
  '#00AB55',
  '#000000',
  '#FFFFFF',
  '#FFC0CB',
  '#FF4842',
  '#1890FF',
  '#94D82D',
  '#FFC107'
];

// ----------------------------------------------------------------------

const products = [...Array(2)].map((_, index) => {
  const setIndex = index + 1;

  return {
    id: faker.datatype.uuid(),
    cover: PRODUCT_IMG[index],
    name: PRODUCT_NAME[index],
    price: PRODUCT_SUB[index],
    priceSale: setIndex % 3 ? null : faker.datatype.number({ min: 19, max: 29, precision: 0.01 }),
    colors:
      (setIndex === 1 && PRODUCT_COLOR.slice(0, 2)) ||
      (setIndex === 2 && PRODUCT_COLOR.slice(1, 3)) ||
      (setIndex === 3 && PRODUCT_COLOR.slice(2, 4)) ||
      (setIndex === 4 && PRODUCT_COLOR.slice(3, 6)) ||
      (setIndex === 23 && PRODUCT_COLOR.slice(4, 6)) ||
      (setIndex === 24 && PRODUCT_COLOR.slice(5, 6)) ||
      PRODUCT_COLOR,
    status: sample(['', '', ''])
  };
});

export default products;
